import AntMainLayout from '../AntMainLayout';
import AntMainFooter from '../AntMainFooter';
import { unpack, pack } from 'msgpackr';
import stringify from '../../utils/stableStringify';
import React, { useEffect, useRef, useCallback, useState, useMemo } from 'react';
import { Navigate, Route, Routes, useRoutes } from 'react-router-dom';
import { BrowserRouter } from 'react-router-dom';
import { useReactToPrint } from 'react-to-print';
import cs from '../../utils/const.js';
import AntTime from '../../utils/AntTime';
import AntAuth from '../../utils/AntAuth';
import AntAPI from '../../utils/AntAPI';
import AntLocalStorage from '../../utils/AntLocalStorage';
import AntCondition from '../../utils/AntCondition';
import AntLocalization from '../../utils/AntLocalization';
import AntResetPassword from '../AntResetPassword';
import AntSetupWizard from '../AntSetupWizard';
import AntToast from '../AntToast';
import AntPrinting from '../AntPrinting';
import { resolveServiceRoutingQuery } from '../../utils/AntServiceRouting';
import { getClientInstanceId } from '../../utils/AntClientInstance';
import createSocketLifecycle from '../../utils/AntSocketLifecycle';

import { AntGlobal, AntSessionContext } from '../../utils/AntContext';

import io from 'socket.io-client';

// Office chỉ làm mới dữ liệu màn hình phục vụ; không hiển thị các cảnh báo vận hành
// dành cho POS để tránh che thao tác khi nhiều món/bàn thay đổi cùng lúc.
const OFFICE_SUPPRESSED_TOAST_ACTIVITIES = new Set([
    'AROrder_RequestWaiter',
    'AROrder_PushDelivery',
    'AROrder_Accident',
    'AROrder_RequestCheckout',
    'AROrder_NewInfo',
    'ARDeliveryItem_ServeCookingChanged',
    'ARDelilveryItem_ServeCookingCreated',
    'ARDelilveryItem_ServeCookingHighestPriority',
    'ARDeliveryItem_ServeCookingCancelled',
    'ARDelilveryItem_ServeServiceCreated',
    'ARDelilveryItem_ServeServiceHighestPriority',
    'ARServeStatus-Changed'
]);

export default function (props) {
    const appGlobal = AntGlobal();

    const refToast = useRef();
    const refPrinter = useRef();

    const [token, setToken] = useState('');
    const [sessionInfo, setSessionInfo] = useState(AntAuth.getSessionInfo());

    const [navItems, setNavItems] = useState([]);
    const [homeUrl, setHomeUrl] = useState('/home');

    const initNavItems = useCallback(() => {
        var ar = appGlobal.appNavigation
            .map((i1) => {
                var isVisible = AntCondition.isVisible(null, i1);
                if (!isVisible) return { ...i1, visible: false };

                if (i1.items instanceof Array) {
                    var ar = i1.items.map((i2) => {
                        return { ...i2, visible: AntCondition.isVisible(null, i2) };
                    });
                    var items = [...ar].filter((f) => f && f.visible);

                    return { ...i1, items, visible: items.length > 0 && AntCondition.isVisible(null, i1) };
                }
                return { ...i1, visible: AntCondition.isVisible(null, i1) };
            })
            .filter((f) => f && f.visible);

        if (ar.length > 0) {
            ar = ar.map((item) => {
                if (item.items instanceof Array && item.items.length === 1 && item.distinctable !== false) {
                    return {
                        text: item.items[0].text,
                        path: item.items[0].path,
                        icon: item.icon,
                        module: item.module,
                        subGroup: item.subGroup,
                        visible: item.items[0].visible,
                        navBadge: item.items[0].navBadge || item.navBadge
                    };
                }
                return item;
            });
        }

        var arNavItems = ar;
        var homeUrl = '/home';

        if (ar.length > 0) {
            var flatAr = ar.map((i) => (i.items instanceof Array ? i.items : i)).flat();
            if (flatAr.length > 0 && !flatAr.some((i) => i.path === '/home')) homeUrl = flatAr[0].path;

            flatAr = flatAr.filter((i) => i.path !== '/home');
            if (flatAr.length === 1) {
                homeUrl = flatAr[0].path;
                arNavItems = flatAr;
            }
        }
        return {
            homeUrl: homeUrl,
            navItems: arNavItems
        };
    }, [appGlobal.appNavigation]);

    const sessionListeners = useRef([]);
    const registerSessionListener = useCallback((e) => {
        let data = {
            id: String(Math.floor(Math.random() * 1000000)) + String(AntTime.nowUnix()),
            listener: e
        };
        sessionListeners.current.push(data);

        return data;
    }, []);
    const clearSessionListener = useCallback((data) => {
        sessionListeners.current = sessionListeners.current.filter((l) => l.id !== data?.id);
    }, []);

    const onSessionChanged = useCallback(() => {
        setSessionInfo(AntAuth.getSessionInfo());
    }, []);

    const socketLifecycle = useRef(null);
    const refreshToken = useCallback((done) => {
        AntAuth.refreshToken(false, null, () => {
            socketLifecycle.current?.sync();
            if (typeof done === 'function') done();
        }, (data) => {
            setToken(data);
            onSessionChanged();
        });
    }, [onSessionChanged]);

    const isResetPassword = Boolean(sessionInfo && sessionInfo.password_expired);
    // User chủ động đổi mật khẩu từ menu người dùng: mở lại đúng màn AntResetPassword, có nút quay lại.
    // Tài khoản chưa đặt mật khẩu thì mục này là "Đặt mật khẩu" và màn không hỏi mật khẩu cũ.
    const hasNoPassword = Boolean(sessionInfo && sessionInfo.no_password);
    const [settingPassword, setSettingPassword] = useState(false);
    const showResetPassword = isResetPassword || settingPassword;
    if (sessionInfo && !sessionInfo.bus_settings) {
        console.warn('[AntMainArea] sessionInfo.bus_settings undefined — wizard check skipped');
    }
    // Wizard CHỈ hiển thị cho business mới signup — flag wizard_pending=1 được
    // set tường minh trong createBusiness. Business cũ không có flag → không hiện.
    // Sau finish wizard, BE set wizard_pending=0 nên flag biến mất khỏi bus_settings.
    const isWizardPending = Boolean(
        sessionInfo &&
            sessionInfo.bus_settings &&
            String(sessionInfo.bus_settings.wizard_pending || '0') === '1'
    );

    const [userMenuItems, setUserMenuItems] = useState([
        {
            text: AntLocalization.translateText({ vi: 'Đăng Xuất', en: 'Log Out', fr: 'Déconnexion', es: 'Cerrar sesión', id: 'Keluar', ja: 'ログアウト', zh: '登出', ko: '로그아웃', hi: 'लॉग आउट', ar: 'تسجيل الخروج' }),
            icon: 'runner',
            onClick: () => {
                AntAuth.logOut();
                if (props.onLogOut) props.onLogOut();
            }
        }
    ]);

    const shownUserMenuItems = useMemo(
        () => [
            {
                text: hasNoPassword
                    ? AntLocalization.translateText({ vi: 'Đặt mật khẩu', en: 'Set password', fr: 'Définir MDP', es: 'Definir clave', id: 'Atur kata sandi', ja: 'パスワードを設定', zh: '设置密码', ko: '비밀번호 설정', hi: 'पासवर्ड सेट करें', ar: 'تعيين كلمة المرور' })
                    : AntLocalization.translateText({ vi: 'Đổi mật khẩu', en: 'Change password', fr: 'Changer MDP', es: 'Cambiar contraseña', id: 'Ubah kata sandi', ja: 'パスワード変更', zh: '更改密码', ko: '비밀번호 변경', hi: 'पासवर्ड बदलें', ar: 'تغيير كلمة المرور' }),
                icon: 'key',
                onClick: () => setSettingPassword(true)
            },
            ...userMenuItems
        ],
        [hasNoPassword, userMenuItems]
    );

    const socket = useRef();
    const socketConnected = useRef(false);
    const hadSocketConnected = useRef(false); // đã từng kết nối → lần 'connect' sau là NỐI LẠI
    // socketLastMessage đã được chuyển sang ref-dispatch (tránh re-render toàn AntMainArea khi nhận socket)
    const socketDispatch = useRef(null);

    const printingQueue = useRef([]);
    const printedMessages = useRef([]);
    const printingQueueProcessing = useRef(false);
    const printingMessage = useRef(null);

    const socketListeners = useRef([]);

    const isSocketConnected = useCallback(() => {
        return socketConnected.current;
    }, []);

    const registerSocketListener = useCallback((e, strName) => {
        if (strName) socketListeners.current = socketListeners.current.filter((l) => l.name !== strName);

        let data = {
            id: String(Math.floor(Math.random() * 1000000)) + String(AntTime.nowUnix()),
            listener: e,
            name: strName
        };
        socketListeners.current.push(data);

        return data;
    }, []);

    const clearSocketListener = useCallback((data, strName) => {
        if (typeof data === 'string') {
            socketListeners.current = socketListeners.current.filter((l) => l.name !== data);
            return;
        }

        socketListeners.current = socketListeners.current.filter((l) => l.id !== data?.id || l.name !== data?.strName);
    }, []);

    const onSocketConnected = useCallback(() => {
        // console.log('Kết nối thành công!');
        socketConnected.current = true;

        // NỐI LẠI sau khi đứt: tin phát ra trong lúc đứt đã mất hẳn (server không bù) →
        // phát tin nội bộ cho MỌI màn đang mở tự tải lại. Broadcast không break;
        // màn chưa xử lý loại tin này sẽ tự bỏ qua (handler lọc theo name/activity).
        if (hadSocketConnected.current) {
            const payload = { name: 'ANTE_SOCKET', event: 'SOCKET_RECONNECTED', data: { activity: 'SOCKET_RECONNECTED' } };
            for (let i = 0; i < socketListeners.current.length; i++) {
                const sListener = socketListeners.current[i];
                if (sListener && sListener.listener) {
                    try {
                        sListener.listener(payload, sListener.name);
                    } catch (e) {
                        /* listener lỗi không chặn listener khác */
                    }
                }
            }
        }
        hadSocketConnected.current = true;
    }, []);

    const onSocketDisConnected = useCallback(() => {
        socketConnected.current = false;
    }, []);

    const onSocketReceiveANTE_MESSAGE = useCallback((data) => {
        // Dispatch trực tiếp qua ref — không dùng setState để tránh re-render AntMainArea
        if (socketDispatch.current) socketDispatch.current(data);
    }, []);

    const connectToSocket = useCallback(() => {
        if (socket.current) return;

        // socket.current?.disconnect();

        const token = localStorage.getItem(cs.System_Code + '-session-token');
        let info = localStorage.getItem(cs.System_Code + '-session-info');
        info = JSON.parse(info);

        // const header = {
        //     Authorization: 'Bearer ' + token,
        //     'business_short_code': info.business_short_code,
        //     'Business-Industry': info.business_industry,
        //     'Business-Sub-Industry': info.business_sub_industry
        // };

        var BaseURL = localStorage.getItem(cs.System_Code + '-Sys_BaseURL');
        if (!BaseURL || BaseURL==='null' || BaseURL ==='undefined' ) BaseURL = cs.BaseURL;

        delete socket.current;
        socket.current = io(BaseURL, {
            path: '/socket.io',
            query: {
                token: AntAuth.getSessionSocketToken(),
                BusinessShortCode: info.business_short_code,
                BusinessZoneCode: info.business_zone_code,
                BusinessIndustry: info.business_industry,
                BusinessSubIndustry: info.business_sub_industry,
                clientInstanceId: getClientInstanceId(),
                ...resolveServiceRoutingQuery(info)
            },
            // extraHeaders: header,
            transports: ['websocket'], // Chỉ định chỉ sử dụng WebSocket
            upgrade: false, // Vô hiệu hóa cơ chế nâng cấp từ polling sang WebSocket,
            autoConnect: false,
            reconnection: true,
            reconnectionAttempts: Infinity,
            reconnectionDelay: 1000,
            reconnectionDelayMax: 10000,
            randomizationFactor: 0.5
        });

        // LoggedIn is sent only after the server accepts the socket token.
        socket.current.on('LoggedIn', onSocketConnected);
        socket.current.on('disconnect', onSocketDisConnected);
        socket.current.on('ANTE_MESSAGE', onSocketReceiveANTE_MESSAGE);
        socketLifecycle.current = createSocketLifecycle(socket.current, () => {
            const currentInfo = AntAuth.getSessionInfo() || {};
            return {
                token: AntAuth.getSessionSocketToken(),
                BusinessShortCode: currentInfo.business_short_code,
                BusinessZoneCode: currentInfo.business_zone_code,
                BusinessIndustry: currentInfo.business_industry,
                BusinessSubIndustry: currentInfo.business_sub_industry,
                // wake() gán lại query bằng hàm này trước mỗi lần nối: thiếu mã tab thì BE không nhận ra tab vừa thao tác.
                clientInstanceId: getClientInstanceId(),
                ...resolveServiceRoutingQuery(currentInfo)
            };
        }, refreshToken);
        socketLifecycle.current.wake();
    }, [onSocketConnected, onSocketDisConnected, onSocketReceiveANTE_MESSAGE, refreshToken]);

    const onShowToast = useCallback((data, onClicked, opts) => {
        if (refToast.current?.showToast) return refToast.current?.showToast(data, onClicked, opts);
    }, []);

    const [sessionContext, setSessionContext] = React.useState({
        onSessionChanged: onSessionChanged,
        isSocketConnected: isSocketConnected,
        registerSessionListener: registerSessionListener,
        registerSocketListener: registerSocketListener,
        clearSessionListener: clearSessionListener,
        clearSocketListener: clearSocketListener,
        showToast: onShowToast
    });

    const onActionPrint = useCallback((msg) => {
        return new Promise(async (resolve) => {
            if (refPrinter.current && msg?.message?.html) {
                let isExisted = printedMessages.current.some((m) => {
                    let diffSeconds = AntTime.diffSecondToNow(m.at);
                    return stringify(m.message) === stringify(msg.message) && diffSeconds < 10;
                });

                if (!isExisted) {
                    printingMessage.current = msg;
                    refPrinter.current.load({ html: msg?.message?.html, height: msg?.message?.htmlHeight });
                }
                resolve(true);
            } else if (refPrinter.current && msg.cnfPrint.printUrl && msg.cnfPrint.module && msg.cnfPrint.table) {
                var body = {};
                if (msg.cnfPrint.repostFields instanceof Array) {
                    for (let i = 0; i < msg.cnfPrint.repostFields.length; i++) {
                        const cnfField = msg.cnfPrint.repostFields[i];
                        if (typeof cnfField === 'string') body[cnfField] = msg.message[cnfField];
                        else body[cnfField.alias] = msg.message[cnfField.dateField];
                    }
                } else {
                    body = {
                        code: msg.message.order_code
                    };
                }

                const mainAPI = new AntAPI(msg.cnfPrint.module, msg.cnfPrint.table);
                mainAPI.post(msg.cnfPrint.printUrl, body, async (resData) => {
                    if (resData.data?.cancel) {
                        resolve();
                        return;
                    }

                    while (printingMessage.current) {
                        await AntTime.sleep(1000);
                    }

                    let isExisted = printedMessages.current.some((m) => {
                        let diffSeconds = AntTime.diffSecondToNow(m.at);
                        return stringify(m.message) === stringify(msg.message) && diffSeconds < 10;
                    });
                    if (!isExisted) {
                        printingMessage.current = msg;
                        refPrinter.current.load(resData.data);
                    }
                    resolve(true);
                });
            } else resolve();
        });
    }, []);

    const handlePrint = useReactToPrint({
        content: () => {
            return refPrinter.current;
        },
        onAfterPrint: () => {
            printedMessages.current.push(printingMessage.current);
            printingMessage.current = null;
            // console.log('In xong!');
            // alert('Đã in xong!');
        }
    });

    const processPrintingQueue = useCallback(async () => {
        while (printingQueueProcessing.current) {
            await AntTime.sleep(1000);
        }

        printingQueueProcessing.current = true;
        while (printingQueue.current.length > 0) {
            const msg = printingQueue.current[0];
            await onActionPrint(msg);
            printingQueue.current.shift();
        }
        printingQueueProcessing.current = false;
    }, [onActionPrint]);

    // Gán socketDispatch.current mỗi render để luôn có closure mới nhất (refreshToken, appGlobal, ...)
    // Không dùng useCallback — việc gán ref trực tiếp trong render body là pattern an toàn
    socketDispatch.current = (data) => {
        if (!data) return;

        if (data.event === 'RefreshToken') {
            refreshToken();
            return;
        }

        const currentStoreCode = AntAuth.getSessionInfo('store_code');
        const eventStoreCode = data.store_code || data.data?.store_code;
        if (eventStoreCode && currentStoreCode && currentStoreCode !== 'ALL_STORES' && String(eventStoreCode) !== String(currentStoreCode)) return;

        if (data.event === 'RemotePrint') {
            if (!eventStoreCode || !currentStoreCode || currentStoreCode === 'ALL_STORES' || String(eventStoreCode) !== String(currentStoreCode)) return;
            let cnfPrint = appGlobal.backgroundPrinters?.find((p) => p.activity === data.activity);
            if (cnfPrint) {
                let isExisted = printingQueue.current.some((m) => {
                    let diffSeconds = AntTime.diffSecondToNow(m.at);
                    return stringify(m.message) === stringify(data) && diffSeconds < 5;
                });
                if (!isExisted) {
                    printingQueue.current.push({ at: AntTime.nowUnix(), message: data, cnfPrint: cnfPrint });
                    processPrintingQueue();
                }
                return;
            }
        }

        for (let i = 0; i < socketListeners.current.length; i++) {
            const sListener = socketListeners.current[i];
            if (sListener && sListener.listener) {
                let handled = sListener.listener(data, sListener.name);
                if (handled) break;
            }
        }
    };

    useEffect(() => {
        var obj = initNavItems();
        setHomeUrl(obj.homeUrl);
        setNavItems(obj.navItems);
    }, [initNavItems]);

    useEffect(() => {
        setSessionInfo(AntAuth.getSessionInfo());

        AntLocalStorage.clearGlobalExpiredKeys();
    }, [token]);

    useEffect(() => {
        if (sessionInfo)
            setSessionContext({
                ...JSON.parse(stringify(sessionInfo)),
                onSessionChanged: onSessionChanged,
                isSocketConnected: isSocketConnected,
                registerSessionListener: registerSessionListener,
                registerSocketListener: registerSocketListener,
                clearSessionListener: clearSessionListener,
                clearSocketListener: clearSocketListener,
                showToast: onShowToast
            });

        var obj = initNavItems();
        setNavItems(obj.navItems);
    }, [
        sessionInfo,
        initNavItems,
        onShowToast,
        onSessionChanged,
        isSocketConnected,
        registerSessionListener,
        clearSessionListener,
        registerSocketListener,
        clearSocketListener
    ]);

    const showToast = useCallback(
        (data) => {
            if (sessionContext.showToast) {
                let isShowToast = props.showToastActivities ? props.showToastActivities.includes(data?.data?.activity) : true;
                let isPlaySound = props.playSoundActivities ? props.playSoundActivities.includes(data?.data?.activity) : true;
                let isPlayTextToSpeech = props.textToSpeechActivities ? props.textToSpeechActivities.includes(data?.data?.activity) : true;

                if (data?.toast_enable === false) isShowToast = false;
                if (data?.sound_enable === false) isPlaySound = false;
                if (data?.speech_enable === false) isPlayTextToSpeech = false;

                return sessionContext.showToast(data, props.onToastClicked, {
                    showToast: isShowToast,
                    playSound: isPlaySound,
                    speakVoice: isPlayTextToSpeech
                });
            }
        },
        [sessionContext, props.onToastClicked, props.showToastActivities, props.playSoundActivities, props.textToSpeechActivities]
    );

    const onSocketReceived = useCallback(
        (data, screenName) => {
            if (data?.byPassOfficeMode) return false;

            if (OFFICE_SUPPRESSED_TOAST_ACTIVITIES.has(data?.data?.activity)) return false;

            if (data?.event === 'notification') return showToast({ ...data, text: data.message, textToSpeech: data.speechMessage });
        },
        [showToast, props.pathName]
    );

    useEffect(() => {
        refreshToken();

        // Tab ẩn: bỏ nhịp làm mới phiên (mỗi tab tự gọi; người dùng mở nhiều tab thì tab nền gọi thừa). Tab hiện lại thì làm
        // mới ngay nếu đã quá 1 phút — giới hạn giờ truy cập vẫn có hiệu lực khi người dùng quay lại.
        let lastRefreshAt = Date.now();
        const refreshIfVisible = () => {
            if (typeof document !== 'undefined' && document.hidden) return;
            lastRefreshAt = Date.now();
            refreshToken();
        };
        const handleVisibility = () => {
            if (!document.hidden && Date.now() - lastRefreshAt >= 1000 * 60) refreshIfVisible();
        };
        document.addEventListener('visibilitychange', handleVisibility);
        const interval = setInterval(refreshIfVisible, 1000 * 60 * 1);

        connectToSocket();

        const handleWakeup = () => {
            socketLifecycle.current?.wake();
        };

        window.addEventListener('focus', handleWakeup);

        // Đóng tab/reload: chủ động ngắt để server dọn ngay thay vì chờ ping-timeout
        const handleBeforeUnload = () => {
            try {
                socketLifecycle.current?.dispose();
            } catch (e) {
                /* silent */
            }
        };
        window.addEventListener('beforeunload', handleBeforeUnload);

        clearSocketListener('AntMainArea');
        registerSocketListener(onSocketReceived, 'AntMainArea');

        return () => {
            socketLifecycle.current?.dispose();
            socketLifecycle.current = null;
            socket.current = null;
            socketConnected.current = false;
            clearInterval(interval);
            document.removeEventListener('visibilitychange', handleVisibility);
            window.removeEventListener('focus', handleWakeup);
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, []);

    return (
        <BrowserRouter>
            <AntSessionContext.Provider value={sessionContext}>
                {isResetPassword && (
                    <Routes>
                        <Route path="*" Component={AntResetPassword} />
                    </Routes>
                )}
                {!isResetPassword && showResetPassword && (
                    <Routes>
                        <Route
                            path="*"
                            element={
                                <AntResetPassword
                                    onCancel={() => setSettingPassword(false)}
                                    onDone={() => {
                                        setSettingPassword(false);
                                        onSessionChanged();
                                    }}
                                />
                            }
                        />
                    </Routes>
                )}
                {!showResetPassword && isWizardPending && (
                    <Routes>
                        <Route path="*" Component={AntSetupWizard} />
                    </Routes>
                )}
                {!showResetPassword && !isWizardPending && (
                    <div style={{ width: '100%', height: '100%', display: 'flex' }}>
                        <AntMainLayout navigateItems={navItems} userMenuItems={shownUserMenuItems}>
                            <Routes>
                                {appGlobal.appRoutes
                                    .filter((r) => AntCondition.isVisible(null, r))
                                    .map((item) => (
                                        <Route key={item.path} path={item.path} Component={item.component} element={item.element} />
                                    ))}
                                <Route path="*" element={<Navigate to={homeUrl} replace />} />
                            </Routes>
                            <AntMainFooter />
                        </AntMainLayout>
                    </div>
                )}
                {!showResetPassword && !isWizardPending && <AntToast ref={refToast} />}
                {!showResetPassword && !isWizardPending && (
                    <div style={{ display: 'none' }}>
                        <AntPrinting ref={refPrinter} appGlobal={appGlobal} onReady={handlePrint} />
                    </div>
                )}
            </AntSessionContext.Provider>
        </BrowserRouter>
    );
}
